import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Form, FormFieldProps, Label, Select } from 'semantic-ui-react';

interface IProps
  extends FieldRenderProps<string, HTMLElement>,
    FormFieldProps {}

const SelectInput: React.FC<IProps> = ({
  label,
  input,
  width,
  options,
  placeholder,
  disabled,
  inputOnChange,
  meta: { touched, error },
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      {label && <label>{label}</label>}
      <Select
        value={input.value}
        placeholder={placeholder}
        options={options}
        disabled={disabled}
        onChange={(e, data) => {
          input.onChange(data.value);
          inputOnChange && inputOnChange(e, data);
        }}
      />
      {touched && error && (
        <Label basic color='red'>
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default SelectInput;
